import { RefreshCw } from 'lucide-react';
import { cn } from '@tsgecart/ui';

export interface AdminRefreshButtonProps {
  onRefresh: () => void;
  isRefreshing?: boolean;
  lastUpdatedLabel?: string;
  className?: string;
}

export function AdminRefreshButton({
  onRefresh,
  isRefreshing,
  lastUpdatedLabel,
  className,
}: AdminRefreshButtonProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      {lastUpdatedLabel && (
        <span className="text-xs text-gray-400" aria-live="polite">
          {lastUpdatedLabel}
        </span>
      )}
      <button
        type="button"
        onClick={onRefresh}
        disabled={isRefreshing}
        aria-label="Refresh dashboard data"
        className="focus-visible:ring-brand flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 text-gray-600 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60"
      >
        <RefreshCw
          className={cn('h-4 w-4', isRefreshing && 'animate-spin motion-reduce:animate-none')}
          aria-hidden="true"
        />
      </button>
    </div>
  );
}
